export const makeStylesheetLink = (() => {
	let href: null | string = null;
	return (): HTMLLinkElement => {
		if (href == null) {
			const link: HTMLLinkElement | null = document.querySelector("head > link[data-gct-stylesheet]");
			href = link?.href ?? "";
		}

		return <link rel="stylesheet" href={href} /> as HTMLLinkElement;
	};
})();
